import { QuoteStatus } from '__generated__/GQL';

import locales from './locales';
import { QuoteFilterStatus } from './types';

export const QUOTES_FILTERS_STATUSES: {
  [key in QuoteFilterStatus]: QuoteStatus[];
} = {
  accepted: [QuoteStatus.Accepted],
  archived: [QuoteStatus.Archived],
  'not-sent': [QuoteStatus.Pending],
  sent: [QuoteStatus.Sent],
};

export const STATUSES: QuoteFilterStatus[] = [
  'not-sent',
  'sent',
  'accepted',
  'archived',
];

export const STATUSES_OPTIONS = STATUSES.map((key) => ({
  label: locales.statuses[key],
  value: key,
}));
